<template>
      <div class="card">
        <div class="card-content">
          <p class="title is-5">
            ¿Cómo añadir un recurso?
          </p>
          <div class="content">
            <img src="/help-maps-party-map-help.png" class="image is-pulled-left" style="margin: 0 1em 0 0">
            <p>Para añadir recursos es tan sencillo como pulsar el botón "Añadir" situado en la parte superior derecha.</p>
            <p>Entonces debes marcar en el mapa la posición del recurso que quieres añadir. Puedes navegar libremente por el mapa, usar el botón que te posiciona geográficamente (número 1 en la imagen) o buscando una calle (número 2 en la imagen).<br /></p>
            <p>Cuando marcas la posición en el mapa en la parte inferior aparece un botón de "Continuar" para terminar el proceso. Te abre un formulario donde terminar de completar los datos para añadir el recurso.</p>
            <p>Gracias por colaborar.</p>
            <br />
          </div>
        </div>
      </div>
</template>

<script>
export default {
  name: "HowToAddModal"
};
</script>

<style></style>
